import { Object3D, Vector2, Vector3 } from 'three';
import { DividedCircleComponent, TextComponent, ButtonComponent } from '@verybigthings/vbt-webvr-framework';
export default class MainMenuComponent extends DividedCircleComponent {
    constructor(options) {
        if (options.innerRadius === undefined)
            options.innerRadius = 0.5;
        if (options.outerRadius === undefined)
            options.outerRadius = 4.2;
        if (options.borderWidth === undefined)
            options.borderWidth = 0;
        if (options.sectorColors !== undefined && options.sectorColors.default === undefined)
            options.sectorColors.default = 0x4023a3;
        if (options.sectorColors !== undefined && options.sectorColors.hover === undefined)
            options.sectorColors.hover = 0xf15573;
        if (options.sectorColors === undefined)
            options.sectorColors = { default: 0x4023a3, hover: 0xf15573 };
        const soundText = new TextComponent({
            background: { color: 'transparent' },
            size: new Vector2(0.75, 0.15),
            pxSize: new Vector2(160, 32),
            text: {
                value: 'SOUND',
                align: 'center',
                style: { color: 'white' },
                autoWrappingHorizontal: true,
                autoWrapping: true,
            },
        });
        soundText.uiObject.translateY(-0.15);
        soundText.uiObject.scale.set(1.5, 1.5, 1.5);
        const soundMeshButton = new ButtonComponent({
            type: 'icon',
            boxColor: 0x666666,
            size: new Vector3(0.6, 0.6, 0.1),
            background: { color: 'transparent' },
            text: {
                value: '',
                style: { color: 'white', weight: '400', size: '46px', family: 'FontAwesome' },
                align: 'center',
                autoWrappingHorizontal: false,
                autoWrapping: false
            }
        });
        soundMeshButton.uiObject.translateY(0.15);
        const soundSegment = new Object3D();
        soundSegment.add(soundText.uiObject, soundMeshButton.uiObject);
        //
        const playText = new TextComponent({
            background: { color: 'transparent' },
            size: new Vector2(0.75, 0.15),
            pxSize: new Vector2(160, 32),
            text: {
                value: 'RESUME',
                align: 'center',
                style: { color: 'white' },
                autoWrappingHorizontal: true,
                autoWrapping: true,
            },
        });
        playText.uiObject.translateY(-0.15);
        playText.uiObject.scale.set(1.5, 1.5, 1.5);
        const playMeshButton = new ButtonComponent({
            type: 'icon',
            boxColor: 0x666666,
            size: new Vector3(0.4, 0.4, 0.1),
            background: { color: 'transparent' },
            text: {
                value: '',
                style: { color: 'white', weight: '400', size: '46px', family: 'FontAwesome' },
                align: 'center'
            }
        });
        playMeshButton.uiObject.translateY(0.15);
        const playSegment = new Object3D();
        playSegment.add(playText.uiObject, playMeshButton.uiObject);
        const exitText = new TextComponent({
            background: { color: 'transparent' },
            size: new Vector2(0.75, 0.15),
            pxSize: new Vector2(160, 32),
            text: {
                value: 'LOBBY',
                align: 'center',
                style: { color: 'white' },
                autoWrappingHorizontal: true,
                autoWrapping: true,
            },
        });
        exitText.uiObject.translateY(-0.15);
        exitText.uiObject.scale.set(1.5, 1.5, 1.5);
        const exitMeshButton = new ButtonComponent({
            type: 'icon',
            boxColor: 0x666666,
            size: new Vector3(0.4, 0.4, 0.1),
            background: { color: 'transparent' },
            text: {
                value: '',
                style: { color: 'white', weight: '400', size: '46px', family: 'FontAwesome' },
                align: 'center'
            }
        });
        exitMeshButton.uiObject.translateY(0.15);
        exitMeshButton.uiObject.scale.setX(-1);
        const exitSegment = new Object3D();
        exitSegment.add(exitText.uiObject, exitMeshButton.uiObject);
        const sectorsData = [
            {
                name: 'Start Experience',
                mesh: playSegment
            },
            {
                name: 'Exit To Lobby',
                mesh: exitSegment
            },
            {
                name: 'Turn On/Off Sound',
                mesh: soundSegment
            }
        ];
        super({
            sectorsData: options.sectorsData || sectorsData,
            innerRadius: options.innerRadius,
            outerRadius: options.outerRadius,
            bgColor: options.bgColor,
            allowMouseEvents: true,
            borderWidth: options.borderWidth,
            borderColor: options.borderColor,
            enableCancelButton: options.enableCancelButton,
            centerText: options.centerText,
            highlightText: ' ',
            sectorColors: options.sectorColors,
        });
        this.soundMeshButton = soundMeshButton;
        this.on('selected', (event) => {
            const eventSector = event.data;
            if (eventSector.sectorData.name === 'Start Experience')
                this.fire('play');
            if (eventSector.sectorData.name === 'Exit To Lobby') {
                this.fire('exit');
            }
            if (eventSector.sectorData.name === 'Turn On/Off Sound')
                this.fire('toggleSound');
            if (this.sectors.indexOf(eventSector) === 2) {
                const nextBtnText = soundMeshButton.options.text.value !== '' ? '' : '';
                soundMeshButton.setText(nextBtnText);
            }
        });
        // this.on('canceled', () => this.fire('canceled'));
    }
}
